import { register, registerAsync } from '@app/utils/type-registry';

// Synchronous Widgets
import './widgets/audio/audio.component';
import './widgets/button/button.component';
import './widgets/check-box/check-box-field.component';
import './widgets/chip-grid/chip-grid.component';
import './widgets/chip-row/chip-row.component';
import './widgets/data-table/data-table.component';
import './widgets/datepicker-field/datepicker-field.component';
import './widgets/default-page/default-page.component';
import './widgets/dialog.component';
import './widgets/directional-layout/directional-layout.component';
import './widgets/expansion-panel/expansion-panel.component';
import './widgets/file-upload-field/file-upload-field.component';
import './widgets/hyperlink/hyperlink.component';
import './widgets/icon/icon.component';
import './widgets/image/image.component';
import './widgets/progress-spinner/progress-spinner.component';
import './widgets/search-box-field/search-box-field.component';
import './widgets/select-field/select-field.component';
import './widgets/slide-toggle-field/slide-toggle-field.component';
import './widgets/tabs/tabs.component';
import './widgets/text-field/text-field.component';
import './widgets/text/text.component';
import './widgets/textarea-field/textarea-field.component';
import './widgets/texthtml/texthtml.component';
import './widgets/toolbar/toolbar.component';
import './widgets/tree-table/tree-table.component';
import './widgets/accordion/accordion.component';
import './widgets/paginator/paginator.component';
import './widgets/chips-field/chips-field.component';
import './widgets/expansion-panel-table/expansion-panel-table.component';
import './widgets/insert-remove-animate.component';
import './widgets/progress-bar.component';
import './structural-widgets/conditional-widget';
import './structural-widgets/data-widget';
import './structural-widgets/data-store';
import './structural-widgets/switch-widget';

import Fragment from '@app/widgets/fragment.component';
import DividerComponent from '@app/widgets/divider.component';
import ListComponent from '@app/widgets/list.component';
import ListItemComponent from '@app/widgets/list-item.component';
import ListSubheaderComponent from '@app/widgets/list-subheader.component';
import ButtonToggleFieldComponent from '@app/widgets/button-toggle-field.component';
import ListItemLinkComponent from './widgets/list-item-link.component';
import ListItemButtonComponent from './widgets/list-item-button.component';
import ActionListComponent from './widgets/action-list.component';
import ForComponent from '@app/widgets/for.component';
import CardComponent from '@app/widgets/card.component';
import CardHeaderComponent from '@app/widgets/card-header.component';
import CardTitleComponent from '@app/widgets/card-title.component';
import CardSubtitleComponent from '@app/widgets/card-subtitle.component';
import CardContentComponent from '@app/widgets/card-content.component';
import CardFooterComponent from '@app/widgets/card-footer.component';
import CardActionsComponent from '@app/widgets/card-actions.component';
import ContainerComponent from '@app/widgets/container.component';
import CardAvatarComponent from '@app/widgets/card-avatar.component';
import ListItemLineComponent from '@app/widgets/list-item-line.component';
import NavListComponent from '@app/widgets/nav-list.component';
import MenuItemButtonComponent from '@app/widgets/menu-item-button.component';
import MenuItemLinkComponent from '@app/widgets/menu-item-link.component';
import SelectionListComponent from '@app/widgets/selection-list.component';
import RadioGroupComponent from '@app/widgets/radio-group.component';
import HttpResourceComponent from '@app/widgets/http-resource.component';

// Sync Widgets
register('Fragment', Fragment);
register('Divider', DividerComponent);
register('Container', ContainerComponent);
register('MenuItemButton', MenuItemButtonComponent);
register('MenuItemLink', MenuItemLinkComponent);
register('Card', CardComponent);
register('CardHeader', CardHeaderComponent);
register('CardTitle', CardTitleComponent);
register('CardSubtitle', CardSubtitleComponent);
register('CardContent', CardContentComponent);
register('CardFooter', CardFooterComponent);
register('CardActions', CardActionsComponent);
register('CardAvatar', CardAvatarComponent);
register('List', ListComponent);
register('ActionList', ActionListComponent);
register('NavList', NavListComponent);
register('ListItem', ListItemComponent);
register('ListItemLine', ListItemLineComponent);
register('ListSubheader', ListSubheaderComponent);
register('ListItemLink', ListItemLinkComponent);
register('ListItemButton', ListItemButtonComponent);
register('ButtonToggleField', ButtonToggleFieldComponent);
register('SelectionList', SelectionListComponent);
register('RadioGroup', RadioGroupComponent);
register('foreach', ForComponent);
register('HttpResource', HttpResourceComponent);

// Async Widgets
registerAsync('chart', () => import('./widgets/chart.component'));
registerAsync('Editor', () => import('./widgets/editor.component'));
registerAsync('qrcode', () => import('./widgets/qr-code.component'));
